<template>
  <div>
    <modal
      :is-visible="showModal"
      is-view
      :toggle="() => $emit('close')"
      width="900px"
      :title="title"
    >
      <!-- Back arrow -->
      <span
        v-if="selected_session?.id"
        class="back-arrow"
      >
        <v-btn
          color="primary-outlined"
          @click="selected_session = null"
        >
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </span>
      <!-- Back arrow -->
      <div v-if="!selected_session?.id">
        <user-details
          :item="item"
          @onSession="onSession"
        />
      </div>
      <div v-else-if="selected_session?.id">
        <user-session-details :item="selected_session" />
      </div>
    </modal>
  </div>
</template>
<script>
export default {
  components: {
    Modal: () => import("@/components/Modals/Modal.vue"),
    UserDetails: () => import("./UserDetails.vue"),
    UserSessionDetails: () => import("./UserSessionDetails.vue"),
  },
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      selected_session: null,
    };
  },
  computed: {
    showModal() {
      return this.item?.id ? true : false;
    },
    title() {
      if (this.selected_session?.sessionId) {
        return "User Session Detail";
      } else {
        return "User Detail";
      }
    },
  },
  methods: {
    onSession(v) {
      this.selected_session = v;
    },
  },
};
</script>
<style lang="sass" scoped>
.back-arrow
  position: absolute
  top: 1.5rem
</style>
